<template>
  <!-- 首页 -->
  <div class="home">
    <basepanel>
      <!-- 顶部图片  视频播放 -->
      <template v-slot:banner>
        <!-- 轮播视频 -->
        <!-- pc端 -->
        <el-carousel
          v-if="!phoneHandle"
          ref="carousel"
          class="header-carousel"
          :autoplay="false"
          @change="changeCarousel"
        >
          <el-carousel-item v-for="(item, index) in headerImg" :key="item.id">
            <img v-if="item.fileType == 'image'" :src="item.defineUrl" alt="热点图" />
            <!-- <div
              :id="'dplayer' + index"
              v-if="item.fileType == 'video'"
              class="dplayer"
            ></div>-->
            <video
              v-if="item.fileType == 'video'"
              class="player"
              :id="'player' + index"
              crossorigin="anonymous"
              muted
            >
              <source :src="item.defineUrl" type="video/mp4" />
            </video>
          </el-carousel-item>
        </el-carousel>

        <!-- 手机端：ios手机无法轮播视频，轮播视频会自动有弹框播放；安卓手机视频层级太高 -->
        <el-carousel
          ref="slideCarousel"
          v-if="phoneHandle"
          class="header-carousel"
          :autoplay="true"
          :interval="5000"
        >
          <el-carousel-item v-for="(item, index) in headerImg" :key="item.id">
            <img :src="item.pic" alt="热点图" />
            <img
              @click="playVideo(index)"
              style="
                width: 20vw;
                height: 60px;
                position: relative;
                top: -21vh;
                left: 40vw;
              "
              src="../assets/images/public/bofang_default.png"
              alt
            />
            <video class="ios-player" style="display: none" :src="item.defineUrl"></video>
          </el-carousel-item>
        </el-carousel>
      </template>

      <!-- <video id="bg-video" crossorigin="anonymous" loop="" autoplay="" muted="">
        <source
          src="http://8.136.115.116:8081/x_cms_assemble_control/jaxrs/anonymous/fileinfo/download/document/c82781a1-d48b-4fe2-988f-084017def786"
          type="video/mp4"
        />
      </video>-->
      <!-- 主要内容区 -->
      <!-- 更多业务 -->
      <div class="outer-box">
        <div class="all-content">
          <panel :content="content[0]">
            <div slot="content">
              <!-- <div class="content wow fadeInUP" id="business"> -->
              <div class="content wow fadeInUP">
                <!-- <router-link
                :to="'/detail/' + cont.id"
                v-for="(cont, index) in businessList"
                :key="index"
                :class="'cont1-item cont1-item-' + (index + 1)"
              >
                <div class="cont1-item-img" v-if="index == 0">
                  <img :src="cont.defineUrl" alt="" />
                </div>
                <div
                  class="cont1-item-introduce"
                  :class="{
                    'cont1-item-introduce-left': index == 0,
                    'cont1-item-introduce-right': index == 1,
                  }"
                >
                  <div class="title-introduce">
                    <p>{{ cont.title }}</p>
                    <p>{{ cont.data.explain }}</p>
                  </div>
                </div>
                <div class="cont1-item-img" v-if="index == 1">
                  <img :src="cont.defineUrl" alt="" />
                </div>
                </router-link>-->
                <lists :categoryId="businessId" :size="6" :prePath="prePath"></lists>
                <router-link class="more1 more" to="/business">
                  <span>更多业务</span>
                </router-link>
              </div>
            </div>
          </panel>
        </div>
      </div>
      <!-- <div class="all-content"> -->
      <!-- 更多方案 -->
      <panel :content="content[1]" v-loading="solutionList.length == 0">
        <div slot="content">
          <!-- <div class="solutions wow" id="solution" :class="{'fadeInUp':windowSol==0}"> -->
          <div class="solutions wow" :class="{'fadeInUp':windowSol==0}">
            <!-- <router-link -->
            <div
              @click="goto(sol.id, 1, 'solution')"
              v-for="(sol, index) in solutionList"
              :key="index"
              :class="'cont-imgsec cont-imgsec-' + (index + 1)"
            >
              <img :src="sol.defineUrl" v-if="sol.defineUrl" alt />
              <div class="sol-content">
                <div class="sol-inner">
                  <p class="sol-subject">{{ sol.data.subject }}</p>
                  <p class="sol-explain sol-show">{{ sol.data.explain|ellipsis }}</p>
                </div>
              </div>
            </div>
            <!-- </router-link> -->
            <router-link class="more" to="/solution">
              <span>更多方案</span>
            </router-link>
          </div>
        </div>
      </panel>
      <!-- </div> -->
      <!-- <img class="profile wow fadeInUp" :src="profileImg" alt="" /> -->
      <!-- 新闻动态 -->
      <div class="outer-box">
        <div class="all-content">
          <panel :content="content[2]">
            <div slot="content">
              <!-- <div class="content content3 wow fadeInUp" id="news"> -->
              <div class="content content3 wow fadeInUp">
                <div class="news-img">
                  <!-- <img :src="newsImg" alt="" /> -->
                  <el-carousel :interval="5000">
                    <el-carousel-item v-for="item in newsCarousel" :key="item.id">
                      <div style="height: 100%" @click="goto(item.id, 2, 'news')">
                        <img :src="item.url" alt />
                        <div class="mews-img-mc">
                          <div class="mews-img-mc-inner">{{ item.title }}</div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <div class="news-lists" v-show="news.length>0">
                  <el-tabs
                    v-model="activeName"
                    @tab-click="handleClick"
                    @mouseover.native="overTag"
                  >
                    <el-tab-pane
                      v-for="(item, index) in news"
                      :key="index"
                      :label="item.description"
                      :name="index.toString()"
                    >
                      <div
                        class="per"
                        v-for="(it, ind) in item.list"
                        :key="ind"
                        @click="toDetail(it.id)"
                      >
                        <div class="per-text">
                          <span class="per-circle"></span>
                          {{ it.title }}
                        </div>
                        <div class="line-time">
                          <!-- {{ it.publishTime.slice(0, 10) }} -->
                          {{it.data.new_data }}
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                  <router-link class="news-lists-more" to="/news">
                    更多
                    <i class="el-icon-d-arrow-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </panel>
          <!-- <panel :content="content[3]">
          <div slot="content">
            <div class="content wow fadeInUp">
              <div
                class="logo-item"
                v-for="(img, ind) in getPartnerImg"
                :key="ind"
              >
                <img :src="img.url" alt="logo" />
              </div>
            </div>
          </div>
          </panel>-->
        </div>
      </div>
    </basepanel>
    <playvideo v-show="showVideo" :url="currentUrl" @showVideoChange="changeVideoShow"></playvideo>
  </div>
</template>

<script>
import panel from "../components/Panel";
import playvideo from "../components/Video";
import basepanel from "../components/BasePanel";
import lists from "../components/Lists";
// import DPlayer from "dplayer";
import { listFileInfoByDocumentId, listNextWithFilter } from "../api/index";
import { WOW } from "wowjs";
import local from "../utils/local";
export default {
  name: "home",
  components: { panel, basepanel,lists, playvideo },
  data() {
    return {
      activeName: "0", //tab切换
      screenWidth: document.body.clientWidth,
      headerImg: [
        //临时本地获取
        {
          fileType: "video",
          defineUrl: require("../assets/video/1.mp4"),
          pic: require("../assets/images/home/1_Moment.jpg")
        },
        {
          fileType: "video",
          defineUrl: require("../assets/video/2.mp4"),
          pic: require("../assets/images/home/2_Moment.jpg")
        },
        {
          fileType: "video",
          defineUrl: require("../assets/video/3.mp4"),
          pic: require("../assets/images/home/3_Moment.jpg")
        },
        {
          fileType: "video",
          defineUrl: require("../assets/video/4.mp4"),
          pic: require("../assets/images/home/4_Moment.jpg")
        },
        {
          fileType: "video",
          defineUrl: require("../assets/video/5.mp4"),
          pic: require("../assets/images/home/5_Moment.jpg")
        }
      ], //轮播图片
      dp: [], //轮播视频播放
      businessList: [], //主营业务
      businessId: this.$map.buscategoryId,
      solutionList: [], //解决方案
      news: [
        {
          description: "企业新闻",
          list: []
        },
        {
          description: "行业动态"
          // list: [],
        }
      ],
      newsCarousel: [],
      content: [
        {
          titleCh: "主营业务",
          titleEn: "Main Business",
          description: ""
        },
        {
          titleCh: "解决方案",
          titleEn: "The Solution",
          description: ""
        },
        {
          titleCh: "新闻动态",
          titleEn: "News and Trends",
          description: ""
        }
        // {
        //   titleCh: "携手共赢",
        //   titleEn: "Win Hand in Hand",
        //   description: "",
        // },
      ],
      // getPartnerImg: [], //合作伙伴
      prevIndex: 0,
      currentUrl: "", //当前正在播放的视频
      showVideo: false,
      windowSol: 0,
      prePath: "business",
      loading: true
    };
  },
  computed: {
    // 处理ios手机视频播放
    phoneHandle: function() {
      return this.screenWidth <= 768 ? true : false;
    }
  },
  methods: {
    //跳转定位处
    getLocal() {
      this.windowSol = 0;
      local.remove("sol");

      this.windowSol =
        document.documentElement.scrollTop || document.body.scrollTop;
      local.set("sol", this.windowSol);
    },
    changeVideoShow(data) {
      this.showVideo = data;
    },
    goto(id, type, name) {
      type == 1
        ? local.set("prePath", "solution")
        : local.set("prePath", "news");
      this.getLocal();
      this.$router.push("/detail/" + name + "/" + id);
      // worldlimit("")
    },
    changeCarousel(index) {
      this.dp[this.prevIndex].currentTime = 0;
      this.dp[this.prevIndex].pause();
      this.dp[index].play();
      this.prevIndex = index;
    },
    playVideo(index) {
      // let video = document.createElement("video");
      // video.src = this.headerImg[index].defineUrl;
      // video.play();
      if (this.isIos()) {
        // ios
        document.getElementsByClassName("ios-player")[index].play();
      } else {
        this.currentUrl = this.headerImg[index].defineUrl;
        // android
        // document.getElementsByClassName("ios-player")[index].play();
        this.showVideo = true;
      }
    },
    // 新闻动态跳详情
    toDetail(id) {
      this.getLocal();
      local.set("prePath", "news");
      this.$router.push("/detail/news/" + id);
    },
    handleClick(tab) {
      console.log(tab);
    },
    overTag(e) {
      //this.getLocal()
      if (e.target.lastChild) {
        if (e.target.lastChild.data) {
          this.news.forEach((item, index) => {
            if (e.target.lastChild.data == item.description) {
              this.activeName = index.toString();
            }
          });
        }
      }
    },
    // 获取热点轮播图
    async getCarousel() {
      let send = {
        url: {
          id: this.$map.carousel
        }
      };
      let res = await listFileInfoByDocumentId(send);
      if (res.type == "success") {
        // // console.log(res);
        // let idata = res.data;
        // idata.map((val) => {
        //   let url = this.$srcUrl + val.id + "/stream";
        //   this.$set(val, "defineUrl", url);
        //   if (idata.length > 0 && val.type && val.type.indexOf("video") > -1) {
        //     // 视频
        //     this.$set(val, "fileType", "video");
        //   } else {
        //     // 图片
        //     this.$set(val, "fileType", "image");
        //   }
        // });
        // this.headerImg = idata;
        if (this.headerImg.length > 0 && !this.phoneHandle) {
          // 设置播放完自动播放下一个
          this.$nextTick(() => {
            this.dp = [...document.getElementsByClassName("player")];
            this.dp.map((val, index) => {
              val.addEventListener("ended", () => {
                if (index < this.dp.length - 1) {
                  this.$refs.carousel.next();
                  this.dp[index + 1].play();
                } else {
                  this.$refs.carousel.setActiveItem(0);
                  this.dp[0].play();
                }
              });
            });
            this.dp[0].play();
          });
        }

        // 加载视频
        // this.$nextTick(() => {
        //   this.headerImg.map((val, index) => {
        //     if (val.fileType == "video") {
        //       // 等dom元素加载完后初始化视频
        //       let options = {
        //         container: document.getElementById("dplayer" + index),
        //         video: {
        //           url: val.defineUrl,
        //           autoplay: true,
        //         },
        //       };
        //       this.dp[index] = new DPlayer(options);
        //     }
        //   });
        //   this.dp[0].play();
        //   this.clickMe();
        //   this.dp.map((val, index) => {
        //     this.dp[index].on("ended", () => {
        //       if (index < this.dp.length - 1) {
        //         this.$refs.carousel.next();
        //         this.dp[index + 1].play();
        //       } else {
        //         this.$refs.carousel.setActiveItem(0);
        //         this.dp[0].play();
        //       }
        //     });
        //   });
        // });
      } else {
        console.log(res.msg);
      }
    },
    // 触发自动播放
    // clickMe() {
    //   // document.getElementById("hidden-btn").click();
    //   this.$nextTick(() => {
    //     console.log(54545);
    //     document.getElementById("dplayer0").click();
    //   });
    // },
    // 主营业务
    // async getBusiness() {
    //   let send = {
    //     url: {
    //       page: 1,
    //       size: 2,
    //     },
    //     data: {
    //       categoryIdList: [this.$map.buscategoryId],
    //       needData: true,
    //     },
    //   };
    //   let res = await listNextWithFilter(send);
    //   if (res.type == "success") {
    //     let businessList = res.data;
    //     businessList.map((val) => {
    //       this.$set(val, "defineUrl", this.$srcHandle(val.pictureList[0]));
    //     });
    //     this.businessList = businessList;
    //   } else {
    //     console.log(res.msg);
    //   }
    // },
    // 解决方案
    async getSolution() {
      let send = {
        url: {
          page: 1,
          size: 9
        },
        data: {
          categoryIdList: [this.$map.solucategoryId],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);

      if (res.type == "success") {
        let solutionList = res.data;
        if (solutionList.length > 0) {
          solutionList.map(val => {
            this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
          });
          solutionList.sort((a, b) => {
            return a.data.number - b.data.number; //升序
            // return  b.data.number-a.data.number ;//降序
          });

          this.solutionList = solutionList;
        }
      } else {
        console.log(res.msg);
      }
    },
    // 公司简介图
    // async getProfileImg() {
    //   let send = {
    //     url: {
    //       id: this.$map.homeprofile,
    //     },
    //   };
    //   let res = await listAllPictures(send);
    //   if (res.type == "success") {
    //     this.profileImg = this.$srcUrl + res.data[0].id;
    //   } else {
    //     console.log(res.msg);
    //   }
    // },
    // 企业新闻
    async getCorporateNews() {
      let send = {
        url: {
          page: 1,
          size: 13
        },
        data: {
          categoryIdList: [this.$map.newscategoryId],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        if (res.data.length > 0) {
          let newsCarousel = res.data.slice(0, 5);
          newsCarousel.map(val => {
            this.$set(val, "url", this.$srcHandle(val.data.imageclipper_1));
          });
          this.newsCarousel = newsCarousel;
          this.news[0].list = res.data.slice(0, 8);
        }
      } else {
        console.log(res.msg);
      }
    },
    // 行业动态
    async getIndustryNews() {
      let send = {
        url: {
          page: 1,
          size: 8
        },
        data: {
          categoryIdList: [this.$map.news2categoryId],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.news[1].list = res.data;
        new WOW().init();
      } else {
        console.log(res.msg);
      }
    },
    // // 获取合作伙伴
    // async getPartner() {
    //   let send = {
    //     url: {
    //       id: this.$map.partner,
    //     },
    //   };
    //   let res = await listAllPictures(send);
    //   if (res.type == "success") {
    //     this.getPartnerImg = res.data;
    //     res.data.map((val, index) => {
    //       this.$set(
    //         this.getPartnerImg[index],
    //         "url",
    //         `${this.$srcUrl}${val.id}`
    //       );
    //     });
    //     new WOW().init();
    //   } else {
    //     console.log(res.msg);
    //   }
    // },
    isIos() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return false;
      }
      if (isIOS) {
        return true;
      }
    },
    // 移动端手指滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector(".el-carousel__container");
      var startPoint = 0;
      var stopPoint = 0;
      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function() {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          startPoint = 0;
          stopPoint = 0;
          return;
        }
        if (startPoint - stopPoint > 0) {
          startPoint = 0;
          stopPoint = 0;
          that.$refs.slideCarousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          startPoint = 0;
          stopPoint = 0;
          that.$refs.slideCarousel.prev();
          return;
        }
      });
    }
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    this.slideBanner();
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    let t = this;
    this.$nextTick(function() {
      t.windowSol = local.get("sol");
      setTimeout(()=>{
        window.scrollTo(0,t.windowSol)
      },500)
    });
  },
  created() {
    let that = this;
    // setTimeout(function(){
    that.getCarousel();
    // this.getBusiness();
    that.getSolution();
    // this.getProfileImg();
    that.getCorporateNews();
    that.getIndustryNews();
    // this.getPartner();
    // },1000)
  },

  beforeRouteEnter(to, from, next) {
    if (!from.name) {
      setTimeout(function() {
        this.windowSol = 0;
        local.set("sol", 0);
        window.scrollTo(0, 0);
      }, 1000);
    }
    next();
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/public.less";
.home {
  height: 100;
  .block {
    position: relative;
  }
  .player {
    object-fit: fill;
    height: 100%;
    width: 100%;
  }
  .all-content {
    .content {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 5vw;
      // 模块1
      .cont1-item {
        text-decoration: none;
        &:hover {
          img {
            transform: scale(1.2);
          }
        }
        .cont1-item-img {
          overflow: hidden;
          img {
            width: 100%;
            -webkit-transition: all 0.5s ease;
            -moz-transition: all 0.5s ease;
            -o-transition: all 0.5s ease;
            transition: all 0.5s ease;
          }
        }
        .cont1-item-introduce {
          display: flex;
          .title-introduce {
            p {
              &:first-of-type {
                font-size: 20px;
                color: #333333;
                font-weight: bold;
              }
              &:last-of-type {
                margin-top: 10px;
                font-size: 14px;
                color: #666666;
                line-height: 20px;
              }
            }
          }
        }
        .cont1-item-introduce-left {
          margin-top: 14px;
          border-left: 5px solid @color-select1;
          margin-left: 3vw;
          padding-left: 16px;
        }
        .cont1-item-introduce-right {
          justify-content: flex-end;
          text-align: right;
          margin-bottom: 14px;
          border-right: 5px solid @color-select1;
          margin-right: 3vw;
          padding-right: 16px;
        }

        &:last-of-type {
          margin-top: 30px;
        }
      }
      // 模块三
      .news-img {
        overflow: hidden;
        cursor: pointer;
        position: relative;
        img {
          width: 100%;
          -webkit-transition: all 0.5s ease;
          -moz-transition: all 0.5s ease;
          -o-transition: all 0.5s ease;
          transition: all 0.5s ease;
          &:hover {
            transform: scale(1.2);
          }
        }
        .mews-img-mc {
          position: absolute;
          width: 100%;
          height: 50px;
          background: rgb(23 21 21 / 60%);
          bottom: 0px;
          text-align: center;
          color: #ffffff;
          line-height: 50px;
          .mews-img-mc-inner {
            // width: 76%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-left: 3%;
          }
        }
      }
      .news-lists {
        position: relative;
        .per {
          display: flex;
          justify-content: space-between;
          text-decoration: none;
          color: #ffffff;
          // line-height: 38px;
          // line-height: 46px;
          color: #333333;

          &:hover {
            color: #0062c3;
          }

          .per-text {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            // font-size: 16px;
            .per-circle {
              display: inline-block;
              width: 6px;
              height: 6px;
              background-color: #0e6cb6;
              margin-right: 4px;
              vertical-align: middle;
            }
          }

          div {
            cursor: pointer;
            img {
              vertical-align: middle;
              margin-right: 15px;
            }
          }
          .line-time {
            text-align: right;
          }
        }
      }
      .news-lists-more {
        position: absolute;
        right: 0;
        top: 0;
        text-decoration: none;
        color: #000;
        // font-size: 20px;
        // height: 34px;
        // line-height: 34px;
      }
      // 模块四
      .logo-item {
        width: 20%;
        height: 12vw;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 80%;
        }
      }
    }
  }
  // 模块2
  .solutions {
    display: flex;
    flex-wrap: wrap;
    width: 92%;
    margin: 0 auto 5vw;
    .cont-imgsec {
      // width: 100%;
      // height: 20vw;
      // height: 16vw;
      max-height: 500px;
      overflow: hidden;
      position: relative;
      margin-bottom: 4px;
      cursor: pointer;
      &:hover {
        > img {
          transform: scale(1.1);
        }
        // > .sol-content {
        //   // background-color: rgba(#000, 0.6);
        //   > .sol-inner {
        //     bottom: 20px;
        //   }
        // }
        > .sol-content .sol-explain {
          opacity: 1;
          position: relative;
          // visibility:visible;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      .sol-content {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        color: #ffffff;
        background-color: rgba(#000, 0.4);
        transition: all 0.5s ease;
        .sol-inner {
          position: absolute;
          // bottom: -60px;
          width: 85%;
          left: 8%;
          transition: all 0.5s ease;
        }
        .sol-subject {
          width: 80%;
          // font-size: 32px;
          // letter-spacing: 4px;
          // margin-bottom: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
        }
        .sol-explain {
          width: 100%;
          // position:absolute;
          // visibility:hidden;
          height: 15vh;
          transition: all 0.5s ease;
          opacity: 0;
          // letter-spacing: 3px;
          // font-size: 18px;
          // line-height: 30px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 2;
        }
      }
    }
    // .cont-imgsec-1 {
    //   width: ~"calc(48% - 8px)";
    //   margin-right: 4px;
    // }
    // .cont-imgsec-2 {
    //   width: 26%;
    //   margin-right: 4px;
    // }
    // .cont-imgsec-3 {
    //   width: 26%;
    // }
    // .cont-imgsec-4 {
    //   width: 26%;
    //   margin-right: 4px;
    // }
    // .cont-imgsec-5 {
    //   width: ~"calc(48% - 8px)";
    //   margin-right: 4px;
    // }
    // .cont-imgsec-6 {
    //   width: 26%;
    // }
    // .cont-imgsec-7 {
    //   width: 26%;
    //   margin-right: 4px;
    // }
    // .cont-imgsec-8 {
    //   width: 26%;
    //   margin-right: 4px;
    // }
    // .cont-imgsec-9 {
    //   width: ~"calc(48% - 8px)";
    // }
  }
  // 公司简介图
  .profile {
    width: 100%;
  }
  // 轮播
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 企业新闻轮播
  .news-img {
    .el-carousel {
      height: 100%;
      /deep/.el-carousel__container {
        height: 100%;
      }
      /deep/.el-carousel__indicators--horizontal {
        left: auto;
        // right: 0;
        .el-carousel__button {
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
      }
    }
  }
  .news-lists {
    /deep/.el-tabs__item.is-active {
      color: #0e6cb6;
    }
    /deep/.el-tabs__active-bar {
      background-color: #0e6cb6;
    }
  }
}

@media screen and (min-width: 1200px) {
  .all-content {
    // max-width: 1248px;
    .cont1-item {
      width: 50%;
    }
    .title-introduce {
      p {
        &:last-of-type {
          width: 18vw;
        }
      }
    }
  }
  .sol-inner {
    position: absolute !important;
    bottom: -90px;
  }
  .sol-subject {
    font-size: 26px;
    letter-spacing: 4px;
    margin-bottom: 2vh;
  }
  .sol-explain {
    height: 8vh;
    letter-spacing: 3px;
    font-size: 16px;
    line-height: 24px;
  }
  .cont-imgsec {
    height: 16vw;
    &:hover {
      > .sol-content {
        // background-color: rgba(#000, 0.6);
        > .sol-inner {
          bottom: 10vh;
        }
        > .sol-explain {
          opacity: 1;
        }
      }
    }
  }
  .cont-imgsec-1 {
    width: ~"calc(48% - 8px)";
    margin-right: 4px;
  }
  .cont-imgsec-2 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-3 {
    width: 26%;
  }
  .cont-imgsec-4 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-5 {
    width: ~"calc(48% - 8px)";
    margin-right: 4px;
  }
  .cont-imgsec-6 {
    width: 26%;
  }
  .cont-imgsec-7 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-8 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-9 {
    width: ~"calc(48% - 8px)";
  }
  .news-img {
    width: 50%;
    img {
      height: 362px;
    }
    /deep/.el-carousel__indicators--horizontal {
      right: -20px;
    }
    .mews-img-mc-inner {
      width: 76%;
      font-size: 20px;
    }
  }
  .news-lists {
    width: 48%;
    margin-left: 2%;
  }
  .per {
    line-height: 46px;
    div {
      font-size: 20px;
    }
    .line-time {
      min-width: 120px;
    }
  }
  /deep/.el-tabs__item {
    font-size: 24px !important;
    height: 60px;
    line-height: 60px;
  }
  .header-carousel /deep/.el-carousel__container {
    // height: 91vh;
    height: 100vh;
  }
  .news-lists-more {
    font-size: 20px;
    height: 34px;
    line-height: 34px;
  }
  // // 首页导航条
  /deep/.banner-outer {
    padding-top: 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .cont1-item {
    width: 50%;
  }
  .title-introduce {
    p {
      &:last-of-type {
        width: 27.4vw;
      }
    }
  }
  .sol-inner {
    position: absolute !important;
    bottom: -180px;
  }
  .sol-subject {
    font-size: 20px;
    letter-spacing: 3px;
    margin-bottom: 70px;
  }
  .sol-explain {
    letter-spacing: 2px;
    font-size: 10px;
    line-height: 15px;
  }
  .cont-imgsec {
    height: 16vw;
    &:hover {
      > .sol-content {
        // background-color: rgba(#000, 0.6);
        > .sol-inner {
          bottom: -4vh;
        }
      }
    }
  }
  .cont-imgsec-1 {
    width: ~"calc(48% - 8px)";
    margin-right: 4px;
  }
  .cont-imgsec-2 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-3 {
    width: 26%;
  }
  .cont-imgsec-4 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-5 {
    width: ~"calc(48% - 8px)";
    margin-right: 4px;
  }
  .cont-imgsec-6 {
    width: 26%;
  }
  .cont-imgsec-7 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-8 {
    width: 26%;
    margin-right: 4px;
  }
  .cont-imgsec-9 {
    width: ~"calc(48% - 8px)";
  }
  .news-img {
    width: 50%;
    img {
      height: 362px;
    }
    /deep/.el-carousel__indicators--horizontal {
      right: -28px;
    }
    .mews-img-mc-inner {
      width: 66%;
    }
  }
  .news-lists {
    width: 48%;
    margin-left: 2%;
  }
  .per {
    line-height: 36px;
    div {
      font-size: 16px;
    }
    .line-time {
      min-width: 150px;
    }
  }
  /deep/.el-tabs__item {
    font-size: 20px !important;
    height: 50px;
    line-height: 50px;
  }
  .header-carousel /deep/.el-carousel__container {
    height: 50vh;
  }
  .news-lists-more {
    font-size: 16px;
    height: 34px;
    line-height: 34px;
  }
}
@media screen and (min-width: 414px) and (max-width: 767px) {
  .cont1-item {
    width: 100%;
  }
  .cont1-item-2 {
    margin-top: 16px;
  }
  .title-introduce {
    p {
      &:last-of-type {
        width: 51vw;
      }
    }
  }
  .sol-inner {
    bottom: 5vw;
    //   position: absolute!important;
    // bottom: -180px;
  }
  .sol-subject {
    font-size: 24px;
    letter-spacing: 3px;
    margin-bottom: px;
  }
  .sol-explain {
    letter-spacing: 2px;
    font-size: 16px;
    line-height: 24px;
  }
  .cont-imgsec {
    width: 100%;
    height: 30vw;
  }
  .cont-imgsec-4,
  .cont-imgsec-5,
  .cont-imgsec-6,
  .cont-imgsec-7,
  .cont-imgsec-8,
  .cont-imgsec-9 {
    display: none;
  }
  .news-img {
    width: 100%;
    height: 30vh;
    margin-bottom: 10px;
    /deep/.el-carousel__indicators--horizontal {
      right: -30px;
    }
    .mews-img-mc-inner {
      width: 66%;
    }
  }
  .news-lists {
    width: 100%;
  }
  .per {
    line-height: 36px;
    div {
      font-size: 16px;
    }
    .line-time {
      min-width: 100px;
    }
  }
  /deep/.el-tabs__item {
    font-size: 18px !important;
    height: 50px;
    line-height: 50px;
  }
  .header-carousel /deep/.el-carousel__container {
    height: 34vh;
  }
  .news-lists-more {
    font-size: 16px;
    height: 34px;
    line-height: 34px;
  }

  .sol-show {
    display: none;
  }
}
@media screen and (max-width: 413px) {
  //phone
  .cont1-item {
    width: 100%;
  }
  .cont1-item-2 {
    margin-top: 16px;
  }
  .title-introduce {
    p {
      &:first-of-type {
        font-size: 16px !important;
      }
      &:last-of-type {
        width: 69vw;
      }
    }
  }
  // .title-border-left {
  //   margin-left: 0 !important;
  //   margin-right: 2vw !important;
  // }
  // .title-border-right {
  //   margin-right: 0 !important;
  //   margin-left: 2vw !important;
  // }
  .sol-inner {
    bottom: 5vw;
  }
  .sol-subject {
    font-size: 18px;
    margin-bottom: 12px;
    letter-spacing: 2px;
  }
  .sol-explain {
    letter-spacing: 2px;
    font-size: 14px;
    line-height: 20px;
  }
  .sol-show {
    display: none !important;
  }
  .cont-imgsec {
    width: 100%;
    height: 34vw;
  }
  .cont-imgsec-4,
  .cont-imgsec-5,
  .cont-imgsec-6,
  .cont-imgsec-7,
  .cont-imgsec-8,
  .cont-imgsec-9 {
    display: none;
  }
  .news-img {
    margin-bottom: 10px;
    width: 100%;
    height: 30vh;
    .mews-img-mc {
      font-size: 14px;
      .mews-img-mc-inner {
        width: 62%;
      }
    }
    /deep/.el-carousel__indicators--horizontal {
      right: -34px;
    }
  }
  .news-lists {
    width: 100%;
  }
  .per {
    line-height: 36px;
    div {
      font-size: 14px;
      line-height: 28px;
    }
    .line-time {
      min-width: 100px;
    }
  }
  /deep/.el-tabs__item {
    font-size: 16px !important;
  }
  .header-carousel /deep/.el-carousel__container {
    height: 30vh;
  }
  /deep/.el-carousel__button {
    width: 14px;
  }
  .news-lists-more {
    font-size: 14px;
    height: 34px;
    line-height: 34px;
  }
  .more1 {
    // border:1px solid red;
    top: -19px;
  }
}
</style>
